import React, { ReactNode } from "react";
import { UserStatus } from "@/services/admin/specialAccessUser.interfaces";
import { PersonAvatar } from "@/components/ui/person-avatar";

export interface UserData {
  name: string;
  email: string;
  status: UserStatus;
  role: string;
  lastLogin: string;
  enrollmentDate: string;
  avatar?: {
    url?: string;
    alt?: string;
  };
}

export interface UserCardActions {
  onEdit?: (userId: string) => void;
  onDelete?: (userId: string) => void;
  onStatusChange?: (userId: string, status: UserStatus) => void;
  onApprove?: (userId: string) => void;
  onClick?: () => void;
}

export interface UserCardProps extends UserCardActions {
  user: UserData;
  userId: string;
  className?: string;
  children?: ReactNode;
}

export const UserCard: React.FC<UserCardProps> = ({
  user,
  userId,
  onEdit,
  onDelete,
  onStatusChange,
  onClick,
  className = "",
  children,
}) => {
  console.log("UserCard", { user });

  return (
    <div
      className={`rounded-lg border bg-white p-6 shadow-sm ${className}`}
      onClick={onClick}
    >
      <div className="mb-4 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <PersonAvatar
            userId={userId}
            userName={user.name}
            avatarUrl={user.avatar?.url}
            size="md"
          />
          <div>
            <h3 className="text-lg font-semibold">{user.name}</h3>
            <p className="text-sm text-neutral-600">{user.email}</p>
          </div>
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            if (onStatusChange) {
              onStatusChange(userId, user.status === "Active" ? "Inactive" : "Active");
            }
          }}
          className={`rounded-full px-3 py-1 text-sm text-white ${
            user.status === "Active" ? "bg-green-500" : "bg-red-500"
          }`}
        >
          {user.status}
        </button>
      </div>
      <div className="space-y-3">
        <div className="flex items-center space-x-2">
          <i className="fa-solid fa-user-tag text-neutral-500"></i>
          <span className="text-neutral-600">{user.role}</span>
        </div>
        <div className="flex items-center space-x-2">
          <i className="fa-solid fa-clock text-neutral-500"></i>
          <span className="text-neutral-600">Last login: {user.lastLogin}</span>
        </div>
        <div className="flex items-center space-x-2">
          <i className="fa-regular fa-calendar text-neutral-500"></i>
          <span className="text-neutral-600">
            Registered: {user.enrollmentDate}
          </span>
        </div>
        <div className="flex space-x-2 pt-2">
          {onEdit && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onEdit(userId);
              }}
              className="rounded-lg bg-neutral-100 p-2 hover:bg-neutral-200"
              aria-label="Edit user"
            >
              <i className="fa-solid fa-pen text-neutral-600"></i>
            </button>
          )}
          {onDelete && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDelete(userId);
              }}
              className="rounded-lg bg-neutral-100 p-2 hover:bg-neutral-200"
              aria-label="Delete user"
            >
              <i className="fa-solid fa-trash text-neutral-600"></i>
            </button>
          )}
        </div>
        {children}
      </div>
    </div>
  );
};
